import { useEffect } from 'react';

const DEFAULT_OG_IMAGE = 'https://www.atlregen.com/images/social/og-image.png';

function setMetaName(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setMetaProp(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

const usePageSeo = ({ title, description, canonical, ogTitle, ogDescription, ogImage } = {}) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMetaName('description', description);
    if (canonical) {
      setCanonical(canonical);
      setMetaProp('og:url', canonical);
    }

    const resolvedOgTitle = ogTitle || title;
    const resolvedOgDesc = ogDescription || description;
    const resolvedOgImage = ogImage || DEFAULT_OG_IMAGE;

    if (resolvedOgTitle) {
      setMetaProp('og:title', resolvedOgTitle);
      setMetaName('twitter:title', resolvedOgTitle);
    }
    if (resolvedOgDesc) {
      setMetaProp('og:description', resolvedOgDesc);
      setMetaName('twitter:description', resolvedOgDesc);
    }
    setMetaProp('og:image', resolvedOgImage);
    setMetaName('twitter:image', resolvedOgImage);
  }, [title, description, canonical, ogTitle, ogDescription, ogImage]);
};

export default usePageSeo;
